//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Dialog, Button } from '../../../../Components/MUIs';
import { Box, Typography } from '@mui/material';
import { Draw as DrawIcon } from '@mui/icons-material';
import Commons from '../../../../Services/Common/Common';
//#endregion

/**
 * 중간/최종 결재자 — 그리드「결재하기」용 서명 팝업
 */
function TRA_CUSTOM_02_ApproverSignModal({
  open,
  onClose,
  onConfirm,
  onRequestReject,
  title,
}) {
  const signatureRef = useRef(null);
  const [signError, setSignError] = useState(false);

  useEffect(() => {
    if (!open) return;
    signatureRef.current?.clear();
    setSignError(false);
  }, [open]);

  const handleClear = () => {
    signatureRef.current?.clear();
    setSignError(false);
  };

  const handleConfirm = async () => {
    const sig = signatureRef.current;
    if (!sig || sig.isEmpty()) {
      setSignError(true);
      return;
    }
    setSignError(false);
    const signatureDataUrl = sig.toDataURL('image/png');
    const decodedData = atob(signatureDataUrl.split(',')[1]);
    const byteNumbers = new Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      byteNumbers[i] = decodedData.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    const file = new File(
      [blob],
      `approver_sign_${Date.now()}.png`,
      { type: 'image/png' }
    );
    const result = await onConfirm?.({ signatureDataUrl, signatureFile: file });
    if (result !== false) {
      onClose?.();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title || '결재하기'}
        </Typography>
      }
      useCloseButton={false}
      useSaveButton={false}
      fullWidth
      maxWidth="sm"
      contentSx={{ pt: 1, pb: 2, px: 2 }}
      content={
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <DrawIcon color="primary" />
            <Typography variant="body2" color="text.secondary">
              아래 영역에 서명한 뒤 확인을 눌러 주세요.
            </Typography>
          </Box>
          <Box
            sx={{
              border: '1px solid #ccc',
              borderRadius: 2,
              p: 1,
              bgcolor: '#fafafa',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                '& .sigCanvas': { display: 'block', width: '100% !important' },
              }}
            >
              <SignatureCanvas
                ref={signatureRef}
                penColor="black"
                minWidth={2}
                maxWidth={4}
                throttle={16}
                canvasProps={{
                  className: 'sigCanvas',
                  style: {
                    height: Commons.IsMobile() ? 200 : 220,
                    width: '100%',
                    borderRadius: 8,
                    backgroundColor: '#E4EFED',
                    border: '1px solid #bdbdbd',
                    touchAction: 'none',
                  },
                }}
                onEnd={() => setSignError(false)}
              />
            </Box>
          </Box>
          {signError && (
            <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
              서명을 입력한 뒤 확인을 눌러 주세요.
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Button
              name="지우기"
              variant="outlined"
              onClick={handleClear}
              sx={{ minWidth: 88, borderColor: '#cfd8dc' }}
            />
            {typeof onRequestReject === 'function' && (
              <Button
                name="반려하기"
                variant="outlined"
                onClick={() => onRequestReject()}
                sx={{
                  minWidth: 88,
                  borderColor: '#e57373',
                  color: '#c62828',
                  '&:hover': { borderColor: '#c62828', bgcolor: '#ffebee' },
                }}
              />
            )}
            <Button
              name="취소"
              variant="outlined"
              onClick={onClose}
              sx={{ minWidth: 88 }}
            />
            <Button
              name="확인"
              variant="contained"
              onClick={handleConfirm}
              sx={{
                minWidth: 88,
                bgcolor: '#1565c0',
                color: '#fff',
                '&:hover': { bgcolor: '#0d47a1' },
              }}
            />
          </Box>
        </Box>
      }
    />
  );
}

export default TRA_CUSTOM_02_ApproverSignModal;
